let Configs = {
    api_url:"https://backend.starmus.com/api/",
    esel_url:"https://go.eset.com/protecting-art-and-smart"
}
export default Configs;